import { requestApi } from './Api';

export const login = async (params) => {
  return await requestApi({
    url: '/user/login',
    params,
    method: 'post',
  });
};

export const checkSession = async (params) => {
  return await requestApi({
    url: '/user/session',
    params,
    method: 'post',
  })
}

export const logout = async (params) => {
  return await requestApi({
    url: '/user/logout',
    params,
    method: 'post',
  });
}

export const confirmMfa = async (params) => {
  return await requestApi({
    url: '/user/mfa/confirm',
    params,
    method: 'post',
  });
}
